import VueRouter from 'vue-router'
let router = new VueRouter({
  routes: [{
      path: '/member',
      component: () => import('@/views/Member'),
      meta: {
        title: '个人中心-中链企通环保网'
      }
    },
    {
      path: '/membership',
      component: () => import('@/views/Membership'),
      meta: {
        title: '会员权益-中链企通环保网'
      }
    },
    {
      path: '/caigou',
      component: () => import('@/views/Caigou'),
      meta: {
        title: '采购信息管理-中链企通环保网'
      }
    },
    {
      path: '/add_caigou',
      component: () => import('@/views/Caigou/addCaigou'),
      meta: {
        title: '发布采购信息-中链企通环保网'
      }
    },
    {
      path: '/caigou_money',
      component: () => import('@/views/Caigou/caigouMoney'),
      meta: {
        title: '采购报价管理-中链企通环保网'
      }
    },{
      path: '/purchased',
      component: () => import('@/views/Caigou/purchased'),
      meta: {
        title: '已购买采购-中链企通环保网'
      }
    },
    {
      path: '/per_order',
      component: () => import('@/views/PerOrder'),
      meta: {
        title: '我的订单-中链企通环保网'
      }
    },
    {
      path: '/per_jifen',
      component: () => import('@/views/PerJifen'),
      meta: {
        title: '我的积分-中链企通环保网'
      }
    },
    {
      path: '/per_shopsc',
      component: () => import('@/views/PerSc/perShopSc'),
      meta: {
        title: '收藏的店铺-中链企通环保网'
      }
    },
    {
      path: '/per_goodssc',
      component: () => import('@/views/PerSc/perGoodsSc'),
      meta: {
        title: '收藏的宝贝-中链企通环保网'
      }
    },
    {
      path: '/per_buy',
      component: () => import('@/views/PerBuy'),
      meta: {
        title: '我的足迹-中链企通环保网'
      }
    },
    {
      path: '/per-yonghu',
      component: () => import('@/views/PerYonghu/userInfo'),
      meta: {
        title: '用户信息-中链企通环保网'
      }
    },
    {
      path: '/per_pass',
      component: () => import('@/views/PerYonghu/perPass'),
      meta: {
        title: '密码修改-中链企通环保网'
      }
    },
    {
      path: '/per_dizhi',
      component: () => import('@/views/PerYonghu/perDizhi'),
      meta: {
        title: '收货地址-中链企通环保网'
      }
    },
    {
      path: '/per_dizhi/editaddress',
      component: () => import('@/views/PerYonghu/editAddress'),
      meta: {
        title: '收货地址-中链企通环保网'
      }
    },
    {
      path: '/jf_shop',
      component: () => import('@/views/PerJifen/jf_shop'),
      meta: {
        title: '积分商城-中链企通环保网'
      }
    },
    {
      path: '/jf_recharge',
      component: () => import('@/views/PerJifen/jf_recharge'),
      meta: {
        title: '积分充值-中链企通环保网'
      }
    },
    {
      path: '/myAssets',
      component: () => import('@/views/Property/myAssets'),
      meta: {
        title: '我的资产-中链企通环保网'
      }
    },
    {
      path: '/myAssets',
      component: () => import('@/views/Property/myAssets'),
      meta: {
        title: '我的资产-中链企通环保网'
      }
    },
    {
      path: '/getCash',
      component: () => import('@/views/Property/getCash'),
      meta: {
        title: '余额提现-中链企通环保网'
      }
    },{
	  path: '/expert',
	  component: () => import('@/views/expert'),
	  meta: {
		title: '申请专家-中链企通环保网'
	  }
	},{
	  path: '/expertList',
	  component: () => import('@/views/expert/list'),
	  meta: {
		title: '申请专家-中链企通环保网'
	  }
	},{
	  path: '/addExpert',
	  component: () => import('@/views/expert/Release'),
	  meta: {
		title: '发布专家-中链企通环保网'
	  }
	},{
	  path: '/revExpert',
	  component: () => import('@/views/expert/Revise'),
	  meta: {
		title: '修改专家-中链企通环保网'
	  }
	},{
      path: '/*',
      redirect: '/member',
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js